import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Divider } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  disabled: boolean;
}

const InsurerFooter: React.FC<Props> = ({ disabled }) => {
  const history = useHistory();
  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/insurers" disabled={disabled} />

        <Button
          block
          type="primary"
          onClick={() => history.push('/app/registry/insurers/create')}
          disabled={!hasPermissions([Authorities.REGISTER_INSURER_ADD])}
        >
          Nova Seguradora
        </Button>
      </SpaceForButton>
    </>
  );
};

export default InsurerFooter;
